import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const NavigationButtons = ({ className = "" }) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const language = i18n.language === 'pt-BR' || i18n.language === 'pt' ? 'pt' : 'en';
  
  const texts = {
    pt: {
      home: 'Início',
      back: 'Voltar'
    },
    en: {
      home: 'Home',
      back: 'Back'
    }
  };
  
  const t = texts[language];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Button
        variant="outline"
        onClick={() => navigate('/')}
        className="flex items-center gap-2"
        data-testid="nav-home-button"
      >
        <Home className="w-4 h-4" />
        {t.home}
      </Button>
      <Button
        variant="outline"
        onClick={() => navigate(-1)}
        className="flex items-center gap-2"
        data-testid="nav-back-button"
      >
        <ArrowLeft className="w-4 h-4" />
        {t.back}
      </Button>
    </div>
  );
};